export default "__VITE_ASSET__BQmx$ryG__"